import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { BusquedaTesoroInstruccionesPage } from './busqueda-tesoro-instrucciones';

@NgModule({
  declarations: [
    BusquedaTesoroInstruccionesPage,
  ],
  imports: [
    IonicPageModule.forChild(BusquedaTesoroInstruccionesPage),
  ],
})
export class BusquedaTesoroInstruccionesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro-instrucciones/busqueda-tesoro-instrucciones.module.ts